import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import store from './store'; // Import your Vuex store

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.afterEach(() => {

    window.scrollTo(0, 0);
    const sidebar = document.querySelector('.sidebar');
    const overlay = document.querySelector('.overlay');
    if (overlay) overlay.classList.remove('show');
    if (sidebar) sidebar.classList.remove('show');
});

// Add a navigation guard
router.beforeEach((to, from, next) => {
    console.log('Navigation Guard Check:', {
        requiresAuth: to.meta.requiresAuth,
        isAuthenticated: store.state.auth.isAuthenticated,
    });
// Reset body overflow before navigating to any route
    document.body.style.overflow = '';
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.state.auth.isAuthenticated) {
            console.log('Redirecting to login');
            next({
                path: '/user/login',
                query: { redirect: to.fullPath },
            });
        } else {

            next();
        }
    } else {
        next();
    }
});

export default router;
